import {
    defaultJsonRequestHeaders,
    handleError,
    reloadOnUnauthorized,
    logError
} from 'tradera/utils/api';
import { cmsApiClient, touchWebClient } from 'tradera/utils/http';

export const getStartPageConfig = (languageCodeIso2) => {
    return cmsApiClient
        .get(`/api/pages/start?locale=${languageCodeIso2}`, {
            headers: defaultJsonRequestHeaders
        })
        .catch(logError)
        .then((response) => response?.data);
};

export const getTrendingBrands = () => {
    return cmsApiClient
        .get('/api/trending/brands', {
            headers: defaultJsonRequestHeaders
        })
        .catch(logError)
        .then((response) => response?.data || [])
        .then((items) =>
            items
                .map(({ name, index, slug, logoImageUrl }) => ({
                    name,
                    index,
                    url: `/brand/${slug}`,
                    logoImageUrl
                }))
                .sort(sortByIndex)
        );
};

const sortByIndex = (a, b) => a.index - b.index;

export const getWishListItems = (itemsPerPage = 8) =>
    touchWebClient
        .get(`/my/api/wish-list?itemsPerPage=${itemsPerPage}`, {
            headers: defaultJsonRequestHeaders
        })
        .catch(handleError())
        .catch(reloadOnUnauthorized)
        .catch(logError)
        .then((response) => response?.data || {});
